/* no-undef */
/* no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { InputWrapperNew, StyledModalNew, StyledBodyNew, StyledHeaderNew, ContainerNew} from './styles';
import { fetchApi, isValidEmail } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import CSVList from '../PeopleHomeV2/CSVList';
import { AdminCloseIcon, FailedIcon, PeoplePageDeleteIcon, RecognitionWarningIcon, UploadHDMIcon } from '../../utils/icons';
import { CommonButtonBorder } from '../common/commonStyles';
import { CommonButtonPopup } from '../HealthCoach/styles';
import { RemoveUser } from '../../redux/constants/apiConstants';
import CommonModal from '../common/CommonModal/CommonModal';


class RemoveEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      csvUpload: false,
      fileName: '',
      showPopUp: false,
      printSampleBiometricCSV:false,
      showDeleteUserConfirmPopup:false,
      showFailedPopup:false,
      disable:false
    }
  }

  componentDidMount() {
    this.setState({
      file: '',
      csvUpload: false,
      fileName: ''
    })
  }

  getCSVHeaders = () => {

    const csvHeaders = [
      { label: "First Name", key: "fname" },
      { label: "Last Name", key: "lname" },
      { label: "Email", key: "user_email" },
    ];
  
    return csvHeaders;
  };

  handleFiles = (e) => {
    this.setState({
      file: '',
      fileName: '',
      csvUpload: false,
    })
    let file = e.target.files[0];
    this.setState({
      file: file,
      fileName: file?.name,
      csvUpload: true, 
    });
    let reader = new FileReader();
    reader.readAsDataURL(file);
    const array = document.getElementById('new-employee-file').value.split("\\");
    let checkCSV = array[array.length -1].split('.');
    if(checkCSV[checkCSV.length -1] == 'csv') {
      reader.onloadend = () => {
        this.setState({
          file: reader.result ? reader.result : 'data:',
          fileName: array[array.length - 1],
          csvUpload: true,
          data: [
            {
              fname: '',
              lname: '',
              mail: ''
            }
          ]
        });
      }
    }
    else {
      toast.error('Please select .csv format only');
      document.getElementById('new-employee-file').value = '';
    }
  }
  
  onChangeInput = (e, index) => {
    const duplicateData  = this.state.data;
    duplicateData[index][e.target.name] = e.target.value;
    this.setState({
      data: duplicateData,
      csvUpload: false,
      fileName: '',
      file: ''
    })    
  }

  preventSpecialChars = (e) => {
    const regex = /^[a-zA-Z\s]$/; // allow alphabets + space
  
    if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
      e.preventDefault(); // Block invalid input
    }
  };

  deleteCSV = () => {
    document.getElementById('new-employee-file').value = '';
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    }, () => {
      this.setState({
        csvUpload: false,
        fileName: '',
        file: ''
      })
    })
  }


    

  addEmployeeInputContainer = () => {
    const duplicateData  = this.state.data;
    
    const obj = {
      fname: '',
      lname: '',
      mail: ''
    }
    duplicateData.push(obj);
    this.setState({
      data: duplicateData
    })
  }

  checkErrorMessage = () => {
    let result = {};
    result['errMessage'] = '';
    result['err'] = false;
    let i = 0;
    while(i<this.state.data.length){
      if(i>0 && this.state.data[i].fname.trim() == '' && this.state.data[i].mail.trim() == '') {
        i += 1;
      }
      else if(this.state.data[i].fname.trim() == '') {
        result['errMessage'] = this.props.t("First name can't be blank");
        result['err'] = true;
        i = this.state.data.length;
      }
      else if(this.state.data[i].mail.trim() == ''){
        result['errMessage'] = this.props.t("Email can't be blank");
        result['err'] = true;
        i = this.state.data.length;
      }
      else if(!isValidEmail(this.state.data[i].mail.trim())) {
        result['errMessage'] = this.props.t('Enter valid email');
        result['err'] = true;
        i = this.state.data.length;
      }
      else {
        i += 1;
      }
    }
    return result;
  }

  addEmployeeButton = () => {
    const { companyId, /*showModalPopUp,*/ companyAuthDetails,  } = this.props;
    const { file, data } = this.state;


    if(companyAuthDetails && companyAuthDetails.length && companyAuthDetails[0].password) {
      let obj = {};
      obj['company_id'] = companyId;
      obj['company_password'] = companyAuthDetails[0].password;

      if(file && file.length > 0) {
        obj['csv_file'] = file;
        obj['file_status'] = 1;
        this.removeUsers(obj);
        this.setState({
          file: '',
          csvUpload: false,
          fileName: '',
        })
        // showModalPopUp();
      }
      else {
        let result = this.checkErrorMessage();

        if(result['err']) {
          toast.error(result['errMessage']);
        }
        else {
          obj['file_status'] = 0;
          obj['employees'] = data;
          this.removeUsers(obj);
          this.setState({
            file: '',
            csvUpload: false,
            fileName: '',
          })
        //   showModalPopUp();
        }
      }      
    }
    else {
      toast.error('Company Password Required')
    }
  };
  addEmployeePopUp = () => {
    this.setState({
      showPopUp: !this.state.showPopUp,
    });
  };

  printAction = (bool) => {
    this.setState({printSampleBiometricCSV:bool});
  }

  removeUsers = async(payload)=>{
    this.setState({disable:true})
    try{
      const res = await fetchApi(RemoveUser,"POST",payload);
      if(res.status === "failed"){
        toast.error(res?.data?.message);
        this.setState({showFailedPopup:true, showDeleteUserConfirmPopup:false})
      }else if(res.status === "success"){
        toast.success(res?.data?.message);
        this.props.showModalPopUp();
        window.setTimeout(() => {
          window.location.reload();
        }, 5100);
        // window.location.reload();
      }
      this.setState({disable:false});
    }catch (error) {
      window.console.error(error);
      this.setState({disable:false});
    }
  }

  

  


  render() {
    const { show, showModalPopUp } = this.props;
    const { fileName, csvUpload, printSampleBiometricCSV, showDeleteUserConfirmPopup,showFailedPopup } = this.state;
    
    return(
      <>

        {!showDeleteUserConfirmPopup && !showFailedPopup ? <StyledModalNew isNewEmployeePopup show={show} onHide={() => {showModalPopUp(); this.setState({fileName: '', csvUpload: '', file: ''})}} >
          <StyledHeaderNew closeButton>
            <ContainerNew style={{flexWrap:"wrap", flexDirection:"row"}}>
              <div className="headerName">
                {this.props.t("Bulk Remove Users")}
              </div>
              
              <div className="cross_img" style={{cursor:'pointer'}} onClick={showModalPopUp}>
                {AdminCloseIcon()}
              </div>
              
            </ContainerNew>
            
          </StyledHeaderNew>
          
          <StyledBodyNew>

            <>
              
              <ContainerNew>
                
              
                {/* Divider */}
                <div style={{ width: '100%', borderBottom: '1px solid #E0E0E0', margin: '16px 0' }} />
                <div className="uploadText">
                  {this.props.t("Upload CSV file to remove employees")}
                </div>
              
                {/* Description */}
                <div
                  className='uploadCSV'
                >
                  {!csvUpload ?<span>
                    {UploadHDMIcon(16,20)}
                  </span> : null}
                  <InputWrapperNew htmlFor="new-employee-file" bgColor={'none'} Color={'none'}>
                    {!csvUpload ?<span>{this.props.t("Upload CSV Now")}</span>:null}
                    <input
                      id="new-employee-file"
                      type="file"
                      name="user"
                      style={{ display: 'none' }}
                      multiple={false}
                      onChange={(e) => { this.handleFiles(e)}}
                      onClick={(e) =>{ e.target.files[0] && this.handleFiles(e);}}
                      accept=".csv"
                    />  
                  </InputWrapperNew>
                </div>
                { csvUpload && 
              <div className="SuccessUpload">
                <div className="deleteIcon" aria-hidden="true" onClick={this.deleteCSV} style={{ cursor:"pointer"}}>{PeoplePageDeleteIcon()} <span className='remove-text'> Remove {fileName} </span></div>
              </div>}
              
              

                <CommonButtonPopup disabled={!this.state.csvUpload} onClick={()=>this.setState({showDeleteUserConfirmPopup:true})} width={'100%'} margin={"20px 0px 0px 0px"}>{this.props.t("Remove Users")}</CommonButtonPopup>

                <CommonButtonBorder margin={"16px 0px"} width={'100%'} onClick={()=>this.setState({printSampleBiometricCSV:true})}>{this.props.t("Download Sample")}</CommonButtonBorder>
              
              </ContainerNew>           
            </>
          </StyledBodyNew>
        </StyledModalNew>: null}
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={[]} />}
        
        {showDeleteUserConfirmPopup  && <CommonModal
          show={showDeleteUserConfirmPopup}
          icon={RecognitionWarningIcon("#CE7841")}
          title="Remove Users"
          description="Are you sure you want to remove these users?"
          subDescription="This action cannot be undone. The user will be permanently removed from the system and will lose access to the platform."
          onCancel={()=>{/*showModalPopUp();*/ this.setState({fileName: '', csvUpload: '', file: '',showDeleteUserConfirmPopup:false})}}
          onConfirm={()=>this.addEmployeeButton()}
          cancelText="Keep Users"
          confirmButtonText="Remove Permanently"
          // buttonIcon={ArchiveIcon()}
          // modalHeight="244px"
          confirmButtonWidth="182px"
          confirmDisabled={this.state.disable}
        />}

        {showFailedPopup  && <CommonModal
          show={showFailedPopup}
          icon={FailedIcon("#CE7841")}
          title="Bulk removal failed"
          description="We were unable to complete the user removal process. Please check your file and try again."
          //   subDescription="This action cannot be undone. The user will be permanently removed from the system and will lose access to the platform."
          onCancel={()=>{/*showModalPopUp();*/ this.setState({showFailedPopup:false});showModalPopUp();}}
          onConfirm={()=>this.setState({showFailedPopup:false})}
          //   cancelText="Keep Users"
          confirmButtonText="Upload Again"
          // buttonIcon={ArchiveIcon()}
          // modalHeight="244px"
          confirmButtonWidth="182px"
          confirmDisabled={this.state.disable}
        />}
      </>
      
    );
  }
}

RemoveEmployee.propTypes = {
  show: PropTypes.bool,
  showModalPopUp: PropTypes.func,
  postAddEmployee: PropTypes.func,
  companyId: PropTypes.number,
  companyAuthDetails: PropTypes.func,
  t: PropTypes.func,
  fetchInactiveUsersList: PropTypes.func,
  inactive : PropTypes.bool,
  companyDetails: PropTypes.func,
  popupMode: PropTypes.string,
  onSwitchMode: PropTypes.func,
  
}

export default ((withTranslation())(RemoveEmployee));

